

import { ApplicationInsights } from '@microsoft/applicationinsights-web';

//  npm install @microsoft/applicationinsights-web --force

const AppInsightsUtility = new ApplicationInsights({
    config: {
      instrumentationKey: '73811e6a-65d2-444f-a3e5-fb7371b74b75', // Azure Instrumentation Key
      enableAutoRouteTracking: true, // Optional: Auto track route changes
    },
  });
  
  AppInsightsUtility.loadAppInsights();
  
  export default AppInsightsUtility;

